import React from 'react';

const About: React.FC = () => {
  const skills = ['React', 'JavaScript','C++','HTML','CSS','Java','C', 'Node.js', 'Python', 'AWS', 'MongoDB'];

  return (
    <section id="about" className="about section">
      <div className="container">
        <h2>About Me</h2>
        <div className="about-content">
          <div className="about-image">
            <div className="profile-photo">
              <img 
                src="/profile.jpg" 
                alt="SuryaChandra Maddha" 
                style={{
                  width: '250px',
                  height: '250px',
                  borderRadius: '50%',
                  objectFit: 'cover',
                  border: '5px solid white',
                  boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
                  transition: 'transform 0.3s ease'
                }}
                onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
              />
            </div>
          </div>
          <div className="about-text">
            <p>
              I'm an aspiring full-stack developer and AI enthusiast actively building my path in the world of modern web technologies and intelligent systems. With a strong foundation in both front-end and back-end development, I'm continuously expanding my skill set to architect scalable, responsive, and user-focused applications. I enjoy working across the stack—turning ideas into interactive interfaces and writing clean, efficient logic behind the scenes.
            </p>
            <p>
              My growing curiosity in artificial intelligence fuels my passion to explore areas like machine learning, deep learning, and AI-driven automation. I'm currently engaged in learning and building projects that intersect software engineering with real-world intelligence, aiming to create tech that adapts, learns, and empowers. Every line of code I write is a step toward becoming a versatile engineer capable of bridging traditional development with cutting-edge AI innovation.
            </p>
            <div className="skills">
              {skills.map((skill, index) => (
                <span key={index} className="skill">{skill}</span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;